import { css } from "@emotion/css";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import type { LicenseStatusResource, LicenseUsageResource, ProjectResource } from "@octopusdeploy/octopus-server-client";
import ConnectTenantsButton from "~/areas/projects/components/ProjectTenants/ConnectTenantsButton";
import { AddOrCloneTenant } from "~/areas/tenants/Tenants/AddOrCloneTenant";
import OnboardingPage from "~/components/GettingStarted/OnboardingPage";
export interface OnboardingProps {
    project: ProjectResource;
    onConnected: (numberOfTenantsConnected: number) => void;
    licenseUsage: LicenseUsageResource | null;
    licenseStatus: LicenseStatusResource | null;
}
export default function Onboarding(props: OnboardingProps) {
    return (<OnboardingPage title="Connect Tenants to start deploying your software to multiple end-customers" intro="Use Tenants to deploy your projects to multiple end-customers, with the software tailored to each specific customer." learnMore={<ExternalLink href="MultiTenantDeployments">Learn more</ExternalLink>} actionButtons={<div className={styles.actionButtonsContainer}>
                    <ConnectTenantsButton {...props}/>
                    <div className={styles.addTenantButton}>
                        <AddOrCloneTenant type="secondary" project={props.project} disableCloning={true} disableCloningReason={"You can only clone tenants that are already connected to this project"} licenseUsage={props.licenseUsage} licenseStatus={props.licenseStatus}/>
                    </div>
                </div>}/>);
}
const styles = {
    actionButtonsContainer: css({
        display: "inline-flex",
    }),
    addTenantButton: css({
        marginLeft: space[16],
    }),
};
